// @flow
import { RutasActionTypes } from './constants';

type RutasAction = { type: string, payload: {} | string };

// common success
export const rutasApiResponseSuccess = (actionType: string, data: any): RutasAction => ({
    type: RutasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const rutasApiResponseError = (actionType: string, error: string): RutasAction => ({
    type: RutasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getRuta = (id: string): RutasAction => ({
    type: RutasActionTypes.GET_RUTA,
    payload: { id },
});

export const addRuta = (ruta:any):RutasAction=>({
    type:RutasActionTypes.ADD_RUTA,
    payload:ruta
})
export const updateRuta = (ruta:any):RutasAction=>({
    type:RutasActionTypes.UPDATE_RUTA,
    payload:ruta
})
export const deleteRuta = (id:string):RutasAction=>({
    type:RutasActionTypes.DELETE_RUTA,
    payload:{id}
})

export const listRutas = (params:any): RutasAction => ({
    type: RutasActionTypes.LIST_RUTAS,
    payload: params,
});

export const setFiltersRutas = (params:any): RutasAction => ({
    type: RutasActionTypes.SET_FILTER,
    payload: params,
})

export const resetRutas = (): RutasAction => ({
    type: RutasActionTypes.RESET,
    payload: {},
});

